// extracted by mini-css-extract-plugin
export default {"header":"PE","light":"QE","dark":"RE","headertitle":"SE","fname":"TE","headerContent":"UE","right":"VE","descriptionwrapper":"WE","appear":"XE","second":"YE","third":"ZE","forth":"aF"};
    if(module.hot) {
      // 1711394579660
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  